import type { SoilColorPalette } from '../../hooks/queries/soilData/useSoilData.models';
import actions from './actions';

interface SoilDataState {
  soilColors: {
    [soilKey: string]: SoilColorPalette;
  };
}

const initialState: SoilDataState = {
  soilColors: {},
};

const reducer = (state = initialState, action: any): SoilDataState => {
  if (action.type === actions.UPDATE_SOIL_COLORS) {
    return {
      ...state,
      soilColors: action.payload,
    };
  }
  return state;
};

export default reducer;
